import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MultiLockingRemovalFormSubmissionComponent } from './multi-locking-removal-form-submission/multi-locking-removal-form-submission.component';
import { MultiLockingRemovalReadonlyComponent } from './multi-locking-removal-readonly/multi-locking-removal-readonly.component';
import { MultiLockingRemovalReportComponent } from './multi-locking-removal-report/multi-locking-removal-report.component';
import { OtpModule } from '../otp.module';
@NgModule({
  declarations: [MultiLockingRemovalFormSubmissionComponent, MultiLockingRemovalReadonlyComponent, MultiLockingRemovalReportComponent,] ,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule,
    OtpModule
  ],
  
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]

})
export class MultiLockingModule { }
